export default "__VITE_ASSET__DP0erx$2__"